export const OBJECT_TYPE_TITLE = 'title';
export const OBJECT_TYPE_RELEASE = 'release';
export const OBJECT_TYPE_METADATA_PRESET = 'metadata-preset';
export const OBJECT_TYPE_CONTENT_PRESET = 'block-preset';
